import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { VisibilityView } from 'pricing-pages-ui-components/components/VisibilityView';
import { jsx as _jsx } from "react/jsx-runtime";
const CurrentPlanButton = ({
  inlineSize,
  maxInlineSize,
  marginInline,
  visible,
  size
}) => {
  return /*#__PURE__*/_jsx(View, {
    inlineSize: inlineSize,
    maxInlineSize: maxInlineSize,
    marginInline: marginInline,
    children: /*#__PURE__*/_jsx(VisibilityView, {
      visible: visible,
      children: /*#__PURE__*/_jsx(Button, {
        disabled: true,
        block: true,
        size: size,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "products.crm.currentPlan"
        })
      })
    })
  });
};
export default CurrentPlanButton;